import React, { useState, useEffect } from 'react';
import styles from './403.module.scss';
import viewDataStyles from './ViewDataTab.module.scss';
import API_BASE_URL from '../../../config/api';
import { useAuth } from '../../../context/AuthContext';
import { normalizeToEnglish } from '../../../utils/digitConverter';
import MainForm from './mainform';
import Signature from './signature';
import ViewData from './viewdata';
import UpdateData from './updatedata';
import VerifyData from './verifydata';

const Form403 = () => {
  const { makeAuthenticatedRequest, user, isAuthenticated } = useAuth();
  const [activeTab, setActiveTab] = useState('main');
  const [signatures, setSignatures] = useState({
    fontwalSignature: null,
    branchHeadSignature: null,
    officeHeadSignature: null
  });

  const [signatureVisibility, setSignatureVisibility] = useState({
    fontwalSignature: false,
    branchHeadSignature: false,
    officeHeadSignature: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formId, setFormId] = useState(null);
  
  // Filter states for view data tab
  const [filters, setFilters] = useState({
    // Top-level form filters (now directly accessible from Form403Item)
    admissionDate: '',
    admissionReportNumber: '',
    officeCode: '',
    officeName: '',
    officeAddress: '',
    fontwalName: '',
    branchHeadName: '',
    officeHeadName: '',
    
    // Item-level filters
    purchaseOrderNumber: '',
    classificationCode: '',
    ledgerPageNumber: '',
    itemName: '',
    specification: '',
    itemIdentificationNumber: '',
    modelNumber: '',
    unit: '',
    quantity: '',
    rate: '',
    totalExcludingVAT: '',
    vat: '',
    totalItemValue: '',
    otherExpenses: '',
    totalWithOtherExpenses: '',
    remarks: '',
    admissionDateFrom: '',
    admissionDateTo: ''
  });
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  
  // Filter visibility state
  const [showFilters, setShowFilters] = useState(false);
  
  // Data update tab states
  const [formList, setFormList] = useState([]);
  const [selectedFormForUpdate, setSelectedFormForUpdate] = useState(null);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [updateFormLoading, setUpdateFormLoading] = useState(false);
  const [updateFormSearchTerm, setUpdateFormSearchTerm] = useState('');
  const [updateFormCurrentPage, setUpdateFormCurrentPage] = useState(1);
  const [updateFormTotalPages, setUpdateFormTotalPages] = useState(1);
  const [updateFormItemsPerPage, setUpdateFormItemsPerPage] = useState(100);
  
  // Data verification tab states
  const [verificationFormList, setVerificationFormList] = useState([]);
  const [verificationLoading, setVerificationLoading] = useState(false);
  const [verificationSearchTerm, setVerificationSearchTerm] = useState('');
  const [verificationCurrentPage, setVerificationCurrentPage] = useState(1);
  const [verificationTotalPages, setVerificationTotalPages] = useState(1);
  const [verificationItemsPerPage, setVerificationItemsPerPage] = useState(10);
  
  // Verification filter states
  const [verificationFilters, setVerificationFilters] = useState({
    // Top-level form filters
    admissionDate: '',
    admissionReportNumber: '',
    officeCode: '',
    officeName: '',
    officeAddress: '',
    fontwalName: '',
    branchHeadName: '',
    officeHeadName: '',
    
    // Item-level filters
    purchaseOrderNumber: '',
    classificationCode: '',
    ledgerPageNumber: '',
    itemName: '',
    specification: '',
    itemIdentificationNumber: '',
    modelNumber: '',
    unit: '',
    quantity: '',
    rate: '',
    totalExcludingVAT: '',
    vat: '',
    totalItemValue: '',
    otherExpenses: '',
    totalWithOtherExpenses: '',
    remarks: '',
    
    // Verification-specific filters
    status: '',
    comment: '',
    location: ''
  });
  
  // Verification filter visibility state
  const [showVerificationFilters, setShowVerificationFilters] = useState(false);
  
  // Verification data state for managing status, comments, and location
  const [verificationData, setVerificationData] = useState({});
  
  // View data tab states
  const [viewDataItems, setViewDataItems] = useState([]);
  const [viewDataLoading, setViewDataLoading] = useState(false);
  const [viewDataForms, setViewDataForms] = useState([]);
  const [selectedFormForView, setSelectedFormForView] = useState(null);
  
  // Signature save states
  const [isSavingSignatures, setIsSavingSignatures] = useState(false);
  
  const [formData, setFormData] = useState({
    // Header Information
    officeName: 'मध्यपश्चिम विश्वविद्यालय',
    officeAddress: 'वीरेन्द्रनगर, सुर्खेत',
    officeCode: '',
    formNumber: '',
    admissionDate: '',
    admissionReportNumber: '',
    reportNumber: '',
    
    // Entity Information
    personName: '',
    entityName: '',
    address: '',
    phoneNumber: '',
    registrationNumber: '',
    panNumber: '',
    
    // Financial Information
    totalAmount: '',
    vatAmount: '',
    grandTotal: '',
    
         // Signature Information
    fontwalName: '',
    fontwalDesignation: '',
    fontwalDate: '',
    branchHeadName: '',
    branchHeadDesignation: '',
    branchHeadDate: '',
    officeHeadName: '',
    officeHeadDesignation: '',
    officeHeadDate: '',
    
    // Firm Information
    firmName: '',
    firmSignature: '',
    firmDate: '',
    
    // Items Data
    items: []
  });

  const [emptyRows, setEmptyRows] = useState([
    { 
      id: 'empty-1', 
      serialNumber: '१', 
      purchaseOrderNumber: '', 
      classificationCode: '', 
      ledgerPageNumber: '', 
      itemName: '', 
      specification: '', 
      itemIdentificationNumber: '', 
      modelNumber: '', 
      unit: '', 
      quantity: '', 
      rate: '', 
      totalExcludingVAT: '', 
      vat: '', 
      totalItemValue: '', 
      otherExpenses: '', 
      totalWithOtherExpenses: '', 
      remarks: '' 
    },
    { 
      id: 'empty-2', 
      serialNumber: '२', 
      purchaseOrderNumber: '', 
      classificationCode: '', 
      ledgerPageNumber: '', 
      itemName: '', 
      specification: '', 
      itemIdentificationNumber: '', 
      modelNumber: '', 
      unit: '', 
      quantity: '', 
      rate: '', 
      totalExcludingVAT: '', 
      vat: '', 
      totalItemValue: '', 
      otherExpenses: '', 
      totalWithOtherExpenses: '', 
      remarks: '' 
    },
    { 
      id: 'empty-3', 
      serialNumber: '३', 
      purchaseOrderNumber: '', 
      classificationCode: '', 
      ledgerPageNumber: '', 
      itemName: '', 
      specification: '', 
      itemIdentificationNumber: '', 
      modelNumber: '', 
      unit: '', 
      quantity: '', 
      rate: '', 
      totalExcludingVAT: '', 
      vat: '', 
      totalItemValue: '', 
      otherExpenses: '', 
      totalWithOtherExpenses: '', 
      remarks: '' 
    },
    { 
      id: 'empty-4', 
      serialNumber: '४', 
      purchaseOrderNumber: '', 
      classificationCode: '', 
      ledgerPageNumber: '', 
      itemName: '', 
      specification: '', 
      itemIdentificationNumber: '', 
      modelNumber: '', 
      unit: '', 
      quantity: '', 
      rate: '', 
      totalExcludingVAT: '', 
      vat: '', 
      totalItemValue: '', 
      otherExpenses: '', 
      totalWithOtherExpenses: '', 
      remarks: '' 
    },
    { 
      id: 'empty-5', 
      serialNumber: '५', 
      purchaseOrderNumber: '', 
      classificationCode: '', 
      ledgerPageNumber: '', 
      itemName: '', 
      specification: '', 
      itemIdentificationNumber: '', 
      modelNumber: '', 
      unit: '', 
      quantity: '', 
      rate: '', 
      totalExcludingVAT: '', 
      vat: '', 
      totalItemValue: '', 
      otherExpenses: '', 
      totalWithOtherExpenses: '', 
      remarks: '' 
    }
  ]);

  // Main form functions
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleDateInput = (field, value) => {
    handleInputChange(field, value);
  };

  const handleReportNumberInput = (field, value) => {
    handleInputChange(field, value);
  };

  const calculateRowTotal = (row) => {
    const quantity = parseFloat(row.quantity) || 0;
    const rate = parseFloat(row.rate) || 0;
    const vat = parseFloat(row.vat) || 0;
    const otherExpenses = parseFloat(row.otherExpenses) || 0;
    
    const totalExcludingVAT = quantity * rate;
    const totalItemValue = totalExcludingVAT + vat;
    const totalWithOtherExpenses = totalItemValue + otherExpenses;
    
    return {
      totalExcludingVAT: totalExcludingVAT.toFixed(2),
      totalItemValue: totalItemValue.toFixed(2),
      totalWithOtherExpenses: totalWithOtherExpenses.toFixed(2)
    };
  };

  const handleRowChange = (rowId, field, value) => {
    setEmptyRows(prev => prev.map(row => {
      if (row.id === rowId) {
        const updatedRow = { ...row, [field]: value };
        if (['quantity', 'rate', 'vat', 'otherExpenses'].includes(field)) {
          const totals = calculateRowTotal(updatedRow);
          return { ...updatedRow, ...totals };
        }
        return updatedRow;
      }
      return row;
    }));
  };

  const addNewRow = () => {
    const newRowNumber = emptyRows.length + 1;
    const newRow = {
      id: `empty-${newRowNumber}`,
      serialNumber: newRowNumber.toString(),
      purchaseOrderNumber: '',
      classificationCode: '',
      ledgerPageNumber: '',
      itemName: '',
      specification: '',
      itemIdentificationNumber: '',
      modelNumber: '',
      unit: '',
      quantity: '',
      rate: '',
      totalExcludingVAT: '',
      vat: '',
      totalItemValue: '',
      otherExpenses: '',
      totalWithOtherExpenses: '',
      remarks: ''
    };
    setEmptyRows(prev => [...prev, newRow]);
  };

  const removeRow = (rowId) => {
    setEmptyRows(prev => prev.filter(row => row.id !== rowId));
  };

  // Signature functions
  const handleSignatureUpload = (type, file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSignatures(prev => ({
          ...prev,
          [type]: {
            file: file,
            preview: e.target.result
          }
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSignatureVisibility = (type) => {
    console.log('Toggling signature visibility for:', type);
    console.log('Current visibility state:', signatureVisibility);
    setSignatureVisibility(prev => {
      const newState = {
      ...prev,
      [type]: !prev[type]
      };
      console.log('New visibility state:', newState);
      return newState;
    });
  };

  const handleSignatureDelete = (type) => {
    setSignatures(prev => ({
      ...prev,
      [type]: null
    }));
  };

  const generateSignature = (type) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = 300;
    canvas.height = 150;
    
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    ctx.strokeStyle = '#333';
    ctx.lineWidth = 2;
    ctx.strokeRect(5, 5, canvas.width - 10, canvas.height - 10);
    
    ctx.fillStyle = '#333';
    ctx.font = 'bold 20px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(`${type} Signature`, canvas.width / 2, 50);
    
    ctx.font = '16px Arial';
    ctx.fillText(new Date().toLocaleDateString(), canvas.width / 2, 80);
    
    canvas.toBlob((blob) => {
      if (blob) {
      const file = new File([blob], `${type}_signature.png`, { type: 'image/png' });
      handleSignatureUpload(type, file);
      }
    }, 'image/png', 0.9);
  };

  // Filter functions
  const handleFilterChange = (field, value) => {
    console.log('Filter changed:', field, '=', value);
    setFilters(prev => ({
      ...prev,
      [field]: value
    }));
    // Reset to first page when filter changes
    setCurrentPage(1);
  };

  const clearAllFilters = () => {
    console.log('Clearing all filters');
    setFilters({
      admissionDate: '',
      admissionReportNumber: '',
      officeCode: '',
      officeName: '',
      officeAddress: '',
      fontwalName: '',
      branchHeadName: '',
      officeHeadName: '',
      purchaseOrderNumber: '',
      classificationCode: '',
      ledgerPageNumber: '',
      itemName: '',
      specification: '',
      itemIdentificationNumber: '',
      modelNumber: '',
      unit: '',
      quantity: '',
      rate: '',
      totalExcludingVAT: '',
      vat: '',
      totalItemValue: '',
      otherExpenses: '',
      totalWithOtherExpenses: '',
      remarks: '',
      admissionDateFrom: '',
      admissionDateTo: ''
    });
    setCurrentPage(1);
  };

  // Check if any filters are active
  const hasActiveFilters = () => {
    return Object.values(filters).some(value => value && typeof value === 'string' && value.trim() !== '');
  };

  const getFilteredRows = () => {
    const dataSource = activeTab === 'viewData' ? viewDataItems : emptyRows;
    console.log('getFilteredRows - dataSource length:', dataSource.length);
    console.log('getFilteredRows - activeTab:', activeTab);
    console.log('getFilteredRows - current filters:', filters);
    
    const filtered = dataSource.filter(row => {
      if (activeTab === 'viewData') {
        // Show ALL items from the database, including placeholder items for forms without items
        if (!row.formId && !row.id) {
          console.log('Filtering out completely empty row:', row);
          return false;
        }
        
        // Helper function for case-insensitive filtering with mixed digit support
        const matchesFilter = (value, filterValue) => {
          if (!filterValue || typeof filterValue !== 'string' || filterValue.trim() === '') return true;
          if (!value) return false;
          
          // Normalize both values to English digits for comparison
          const normalizedValue = normalizeToEnglish(value.toString().toLowerCase());
          const normalizedFilterValue = normalizeToEnglish(filterValue.toLowerCase());
          
          return normalizedValue.includes(normalizedFilterValue);
        };
        
        // Apply filters for viewData tab - now using direct fields from Form403Item
        if (filters.admissionDate && !matchesFilter(row.admission_date, filters.admissionDate)) {
          console.log('Filtered out by admissionDate:', row.admission_date, 'does not match', filters.admissionDate);
          return false;
        }
        if (filters.admissionReportNumber && !matchesFilter(row.admission_report_number, filters.admissionReportNumber)) {
          console.log('Filtered out by admissionReportNumber:', row.admission_report_number, 'does not match', filters.admissionReportNumber);
          return false;
        }
        if (filters.officeCode && !matchesFilter(row.office_code, filters.officeCode)) {
          console.log('Filtered out by officeCode:', row.office_code, 'does not match', filters.officeCode);
          return false;
        }
        if (filters.officeName && !matchesFilter(row.office_name, filters.officeName)) {
          console.log('Filtered out by officeName:', row.office_name, 'does not match', filters.officeName);
          return false;
        }
        if (filters.officeAddress && !matchesFilter(row.office_address, filters.officeAddress)) {
          console.log('Filtered out by officeAddress:', row.office_address, 'does not match', filters.officeAddress);
          return false;
        }
        if (filters.fontwalName && !matchesFilter(row.fontwalName, filters.fontwalName)) {
          console.log('Filtered out by fontwalName:', row.fontwalName, 'does not match', filters.fontwalName);
          return false;
        }
        if (filters.branchHeadName && !matchesFilter(row.branchHeadName, filters.branchHeadName)) {
          console.log('Filtered out by branchHeadName:', row.branchHeadName, 'does not match', filters.branchHeadName);
          return false;
        }
        if (filters.officeHeadName && !matchesFilter(row.officeHeadName, filters.officeHeadName)) {
          console.log('Filtered out by officeHeadName:', row.officeHeadName, 'does not match', filters.officeHeadName);
          return false;
        }
        
        // Item-level filters
        if (filters.purchaseOrderNumber && !matchesFilter(row.purchase_order_number, filters.purchaseOrderNumber)) {
          console.log('Filtered out by purchaseOrderNumber:', row.purchase_order_number, 'does not match', filters.purchaseOrderNumber);
          return false;
        }
        if (filters.classificationCode && !matchesFilter(row.classification_code, filters.classificationCode)) {
          console.log('Filtered out by classificationCode:', row.classification_code, 'does not match', filters.classificationCode);
          return false;
        }
        if (filters.ledgerPageNumber && !matchesFilter(row.ledger_page_number, filters.ledgerPageNumber)) {
          console.log('Filtered out by ledgerPageNumber:', row.ledger_page_number, 'does not match', filters.ledgerPageNumber);
          return false;
        }
        if (filters.itemName && !matchesFilter(row.item_name, filters.itemName)) {
          console.log('Filtered out by itemName:', row.item_name, 'does not match', filters.itemName);
          return false;
        }
        if (filters.specification && !matchesFilter(row.specification, filters.specification)) {
          console.log('Filtered out by specification:', row.specification, 'does not match', filters.specification);
          return false;
        }
        if (filters.itemIdentificationNumber && !matchesFilter(row.item_identification_number, filters.itemIdentificationNumber)) {
          console.log('Filtered out by itemIdentificationNumber:', row.item_identification_number, 'does not match', filters.itemIdentificationNumber);
          return false;
        }
        if (filters.modelNumber && !matchesFilter(row.model_number, filters.modelNumber)) {
          console.log('Filtered out by modelNumber:', row.model_number, 'does not match', filters.modelNumber);
          return false;
        }
        if (filters.rate && !matchesFilter(row.rate, filters.rate)) {
          console.log('Filtered out by rate:', row.rate, 'does not match', filters.rate);
          return false;
        }
        if (filters.otherExpenses && !matchesFilter(row.other_expenses, filters.otherExpenses)) {
          console.log('Filtered out by otherExpenses:', row.other_expenses, 'does not match', filters.otherExpenses);
          return false;
        }
        if (filters.totalWithOtherExpenses && !matchesFilter(row.total_with_other_expenses, filters.totalWithOtherExpenses)) {
          console.log('Filtered out by totalWithOtherExpenses:', row.total_with_other_expenses, 'does not match', filters.totalWithOtherExpenses);
          return false;
        }
        if (filters.remarks && !matchesFilter(row.remarks, filters.remarks)) {
          console.log('Filtered out by remarks:', row.remarks, 'does not match', filters.remarks);
          return false;
        }
        
        // Show all items that have a form association, even if they have no data
        console.log('Including item:', row.item_name || 'No name', 'from form:', row.formId);
        return true;
      } else {
        // For main form tab, check if itemName exists and is not empty
        if (!row.itemName || row.itemName.trim() === '') return false;
      }
      
      return true;
    });
    
    console.log('getFilteredRows - final filtered count:', filtered.length);
    return filtered;
  };

  const getPaginatedRows = () => {
    const filteredRows = getFilteredRows();
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredRows.slice(startIndex, endIndex);
  };

  const totalPages = Math.ceil(getFilteredRows().length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  // Verification filter functions
  const handleVerificationFilterChange = (field, value) => {
    setVerificationFilters(prev => ({
      ...prev,
      [field]: value
    }));
    setVerificationCurrentPage(1); // Reset to first page when filter changes
  };

  const getFilteredVerificationRows = () => {
    if (!verificationFormList || verificationFormList.length === 0) {
      console.log('No verification form list available');
      return [];
    }

    console.log('Starting verification filter with:', {
      totalItems: verificationFormList.length,
      filters: verificationFilters,
      verificationDataKeys: Object.keys(verificationData)
    });

    let filtered = [...verificationFormList];

    // Apply filters with mixed digit support
    Object.keys(verificationFilters).forEach(filterKey => {
      const filterValue = verificationFilters[filterKey];
      if (filterValue && filterValue.trim() !== '') {
        console.log(`Applying filter: ${filterKey} = "${filterValue}"`);
        
        filtered = filtered.filter(item => {
          let itemValue = '';
          
          // Handle verification-specific filters
          if (filterKey === 'status' || filterKey === 'comment' || filterKey === 'location') {
            const verification = verificationData[item.id];
            if (verification) {
              itemValue = verification[filterKey] || '';
            }
          } else {
            // Handle item-level filters
            itemValue = item[filterKey] || '';
          }
          
          // Normalize both the item value and filter value to English digits for comparison
          const normalizedItemValue = normalizeToEnglish(String(itemValue).toLowerCase());
          const normalizedFilterValue = normalizeToEnglish(filterValue.toLowerCase());
          
          const matches = normalizedItemValue.includes(normalizedFilterValue);
          
          if (!matches) {
            console.log(`Filtered out item ${item.id} (${item.item_name || 'No name'}):`, {
              filterKey,
              originalItemValue: itemValue,
              normalizedItemValue,
              filterValue,
              normalizedFilterValue
            });
          }
          
          return matches;
        });
        
        console.log(`After filter ${filterKey}: ${filtered.length} items remaining`);
      }
    });

    // Maintain the same sorting order as established in fetchVerificationFormList
    // Sort by order_number in ASCENDING order to show Excel Row 1 first (since it has lowest order_number)
    filtered.sort((a, b) => {
      const orderA = parseInt(a.order_number) || 0;
      const orderB = parseInt(b.order_number) || 0;
      return orderA - orderB; // Ascending order - lowest order_number first (Excel Row 1)
    });

    console.log('Final filtered count:', filtered.length);
    console.log('Filtered items sorted by creation date (oldest first):', filtered.map(item => ({
      id: item.id,
      item_name: item.item_name,
      created_at: item.created_at
    })));
    return filtered;
  };

  const toggleVerificationFilters = () => {
    setShowVerificationFilters(!showVerificationFilters);
  };

  // View data functions
  const fetchViewData = async () => {
    try {
      setViewDataLoading(true);
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/`);
      if (!response.ok) {
        throw new Error('Failed to fetch form data');
      }
      
      const data = await response.json();
      console.log('View data response:', data);
      console.log('Raw API response structure:', JSON.stringify(data, null, 2));
      
      // Ensure data.results is an array
      const results = data.results || [];
      console.log('Forms loaded:', results.length);
      setViewDataForms(results);
      
      const allItems = [];
      
      // Process all forms - show each form as a separate row with all its data
      if (Array.isArray(results)) {
        results.forEach(form => {
          console.log(`Processing form ${form.id}: ${form.form_number} - Items: ${form.items ? form.items.length : 0}`);
          
          if (form && form.items && Array.isArray(form.items) && form.items.length > 0) {
            // Process existing items
            form.items.forEach(item => {
              console.log(`Processing item: ${item.item_name || 'No name'} from form ${form.id}`);
              const processedItem = {
                ...item,
                formId: form.id,
                formNumber: form.form_number,
                // Form-level fields are now directly in the item model
                personName: form.person_name,
                entityName: form.entity_name,
                address: form.address,
                phoneNumber: form.phone_number,
                registrationNumber: form.registration_number,
                panNumber: form.pan_number,
                totalAmount: form.total_amount,
                vatAmount: form.vat_amount,
                grandTotal: form.grand_total,
                fontwalName: form.fontwal_name,
                branchHeadName: form.branch_head_name,
                officeHeadName: form.office_head_name,
                // Add creation timestamp for sorting
                created_at: form.created_at || item.created_at || new Date().toISOString(),
                form_created_at: form.created_at || new Date().toISOString()
              };
              console.log('Processed item with formId:', processedItem.formId, 'item_name:', processedItem.item_name);
              allItems.push(processedItem);
            });
          } else {
            // For forms without items, we should not create placeholder rows
            // Only show actual item data in the table
            console.log(`Form ${form.id} has no items - skipping from item summary table`);
          }
        });
      }
      
      // Sort items by order_number in ASCENDING order to show Excel Row 1 first (since it has lowest order_number)
      // Excel Row 1 = lowest order_number, Excel Row 218 = highest order_number (SEQUENTIAL STORAGE)
      // Display shows Excel Row 1 first, Excel Row 218 last (ORIGINAL EXCEL ORDER)
                  allItems.sort((a, b) => {
              const orderA = parseInt(a.order_number) || 0;
              const orderB = parseInt(b.order_number) || 0;
              return orderA - orderB; // Ascending order - lowest order_number first (Excel Row 1)
            });
      
      console.log('Processed items:', allItems);
      console.log('Items with names:', allItems.filter(item => item.item_name && item.item_name.trim() !== ''));
      console.log('Items with any data:', allItems.filter(item => {
        return item.item_name || item.purchase_order_number || item.classification_code || 
               item.ledger_page_number || item.specification || item.item_identification_number || 
               item.model_number || item.unit || item.quantity || item.rate || 
               item.total_excluding_vat || item.vat || item.total_item_value || 
               item.other_expenses || item.total_with_other_expenses || item.remarks;
      }));
      
      // Debug: Show first few items in detail
      if (allItems.length > 0) {
        console.log('First item details:', allItems[0]);
        console.log('Sample items for filtering test:', allItems.slice(0, 3));
        console.log('All items admission dates:', allItems.map(item => ({
          id: item.id,
          formId: item.formId,
          admissionDate: item.admissionDate,
          admissionReportNumber: item.admissionReportNumber,
          officeCode: item.officeCode,
          created_at: item.created_at,
          form_created_at: item.form_created_at
        })));
        console.log('=== ALL ITEMS DETAILED VIEW ===');
        allItems.forEach((item, index) => {
          console.log(`Item ${index + 1}:`, {
            id: item.id,
            formId: item.formId,
            item_name: item.item_name,
            purchase_order_number: item.purchase_order_number,
            quantity: item.quantity,
            rate: item.rate,
            total_excluding_vat: item.total_excluding_vat,
            vat: item.vat,
            total_item_value: item.total_item_value,
            created_at: item.created_at,
            form_created_at: item.form_created_at
          });
        });
        console.log('=== END ALL ITEMS DETAILED VIEW ===');
      }
      setViewDataItems(allItems);
      
      // Don't automatically select a form - let user choose or show all data
      // if (results && results.length > 0) {
      //   setSelectedFormForView(results[0]);
      // }
    } catch (error) {
      console.error('Error fetching view data:', error);
    } finally {
      setViewDataLoading(false);
    }
  };

  // Data update functions
  const fetchFormList = async (page = 1) => {
    try {
      console.log('fetchFormList called with page:', page);
      setUpdateFormLoading(true);
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('items_per_page', updateFormItemsPerPage);
      
      if (updateFormSearchTerm) {
        params.append('search', updateFormSearchTerm);
      }
      
      const url = `${API_BASE_URL}/api/form403/enhanced-list-for-update/?${params.toString()}`;
      console.log('Making request to:', url);
      
      // Use the enhanced API endpoint
      const response = await makeAuthenticatedRequest(url);
      console.log('Response status:', response.status);
      console.log('Response ok:', response.ok);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Response error text:', errorText);
        throw new Error(`Failed to fetch form list: ${response.status} ${errorText}`);
      }
      
      const data = await response.json();
      console.log('Response data:', data);
      
      setFormList(data.results || []);
      setUpdateFormTotalPages(data.total_pages || 1);
      setUpdateFormCurrentPage(page);
      
      console.log('Enhanced form list fetched:', {
        count: data.count,
        total_pages: data.total_pages,
        current_page: data.current_page,
        filters_applied: data.filters_applied
      });
    } catch (error) {
      console.error('Error fetching form list:', error);
    } finally {
      setUpdateFormLoading(false);
    }
  };

  const handleUpdateFormSearch = (e) => {
    setUpdateFormSearchTerm(e.target.value);
    setUpdateFormCurrentPage(1);
  };

  const handleUpdateFormPageChange = (page) => {
    setUpdateFormCurrentPage(page);
  };

  const handleUpdateFormItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    setUpdateFormItemsPerPage(newItemsPerPage);
    setUpdateFormCurrentPage(1);
  };

  // Bulk operations functions
  const handleBulkDelete = async (formIds) => {
    try {
      const confirmed = window.confirm(`तपाईं ${formIds.length} फारमहरू मेटाउन निश्चित हुनुहुन्छ? यो कार्य फिर्ता गर्न सकिँदैन।`);
      if (!confirmed) return;

      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/bulk-delete/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ form_ids: formIds })
      });

      if (response.ok) {
        const result = await response.json();
        showSuccessPopup(`सफलतापूर्वक ${result.deleted_count} फारमहरू मेटाइयो!`);
        fetchFormList(updateFormCurrentPage); // Refresh the list
      } else {
        const errorData = await response.json();
        showErrorPopup(`मेटाउनेमा समस्या भयो: ${errorData.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error during bulk delete:', error);
      showErrorPopup('मेटाउनेमा समस्या भयो!');
    }
  };

  const handleBulkExport = async (formIds) => {
    try {
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/bulk-export/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ form_ids: formIds })
      });

      if (response.ok) {
        // Handle file download
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `form403_export_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        
        showSuccessPopup('फारमहरू सफलतापूर्वक निर्यात गरियो!');
      } else {
        const errorData = await response.json();
        showErrorPopup(`निर्यातमा समस्या भयो: ${errorData.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error during bulk export:', error);
      showErrorPopup('निर्यातमा समस्या भयो!');
    }
  };

  const handleDuplicateForm = async (formId) => {
    try {
      const confirmed = window.confirm('तपाईं यो फारम नक्कल बनाउन चाहनुहुन्छ?');
      if (!confirmed) return;

      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/${formId}/duplicate-form/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const result = await response.json();
        showSuccessPopup(`फारम सफलतापूर्वक नक्कल गरियो! नयाँ फारम नं: ${result.new_form_number}`);
        fetchFormList(updateFormCurrentPage); // Refresh the list
      } else {
        const errorData = await response.json();
        showErrorPopup(`नक्कल बनाउनेमा समस्या भयो: ${errorData.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error duplicating form:', error);
      showErrorPopup('नक्कल बनाउनेमा समस्या भयो!');
    }
  };

  const handleFormSelectForUpdate = async (formId) => {
    try {
      console.log('handleFormSelectForUpdate called with formId:', formId);
      setUpdateFormLoading(true);
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/${formId}/`);
      if (response.ok) {
        const data = await response.json();
        console.log('Form data received for update:', data);
        setSelectedFormForUpdate(data);
        setShowUpdateForm(true);
        setActiveTab('main');
      }
    } catch (error) {
      console.error('Error loading form for update:', error);
    } finally {
      setUpdateFormLoading(false);
    }
  };

  // Data verification functions
  const fetchVerificationFormList = async (page = 1) => {
    try {
      setVerificationLoading(true);
      
      // Use the Form403Item API to get individual items data
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403-items/`);
      if (!response.ok) {
        throw new Error('Failed to fetch verification data');
      }
      
      const data = await response.json();
      console.log('Verification data received:', data);
      console.log('Verification items count:', data.results?.length || 0);
      
      // Set the verification form list to the items data
      const items = data.results || [];
      
      // Sort items by order_number to maintain Excel upload order exactly as uploaded
      // First row in Excel = order_number 1, Second row = order_number 2, etc.
      items.sort((a, b) => {
        const orderA = parseInt(a.order_number) || 0;
        const orderB = parseInt(b.order_number) || 0;
        return orderA - orderB; // Ascending order - first row first
      });
      
      setVerificationFormList(items);
      
      console.log('Set verification form list with items:', items.length);
      console.log('Sample items:', items.slice(0, 3));
      console.log('Items sorted by creation date (oldest first):', items.map(item => ({
        id: item.id,
        item_name: item.item_name,
        created_at: item.created_at
      })));
      
      // Calculate total pages based on filtered data
      const filteredData = getFilteredVerificationRows();
      setVerificationTotalPages(Math.ceil(filteredData.length / verificationItemsPerPage));
      setVerificationCurrentPage(page);
    } catch (error) {
      console.error('Error fetching verification form list:', error);
    } finally {
      setVerificationLoading(false);
    }
  };

  const handleVerificationSearch = (e) => {
    setVerificationSearchTerm(e.target.value);
    setVerificationCurrentPage(1);
  };

  const handleVerificationPageChange = (page) => {
    setVerificationCurrentPage(page);
  };

  const handleVerificationItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    setVerificationItemsPerPage(newItemsPerPage);
    setVerificationCurrentPage(1);
  };

  // Handle verification status change
  const handleVerificationStatusChange = (itemId, isApproved) => {
    console.log('Status change for item:', itemId, 'isApproved:', isApproved);
    setVerificationData(prev => {
      const newData = {
        ...prev,
        [itemId]: {
          ...prev[itemId],
          status: isApproved ? 'approved' : 'pending'
        }
      };
      console.log('Updated verification data:', newData);
      return newData;
    });
  };

  // Handle verification comment change
  const handleVerificationCommentChange = (itemId, comment) => {
    console.log('Comment change for item:', itemId, 'comment:', comment);
    setVerificationData(prev => {
      const newData = {
        ...prev,
        [itemId]: {
          ...prev[itemId],
          comment: comment
        }
      };
      console.log('Updated verification data:', newData);
      return newData;
    });
  };

  // Handle verification location change
  const handleVerificationLocationChange = (itemId, location) => {
    console.log('Location change for item:', itemId, 'location:', location);
    setVerificationData(prev => {
      const newData = {
        ...prev,
        [itemId]: {
          ...prev[itemId],
          location: location
        }
      };
      console.log('Updated verification data:', newData);
      return newData;
    });
  };

  // Save verification data to backend
  const saveVerificationData = async (itemId, verificationData) => {
    try {
      console.log('Saving verification data for item:', itemId, verificationData);
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403-item-verification/bulk_update_verification/`, {
        method: 'POST',
        body: JSON.stringify({
          updates: [{
            item_id: itemId,
            status: verificationData.status,
            comment: verificationData.comment,
            location: verificationData.location
          }]
        })
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('Verification data saved successfully for item:', itemId, result);
        
        // Update local state to reflect the saved data
        setVerificationData(prev => ({
          ...prev,
          [itemId]: {
            ...prev[itemId],
            ...verificationData
          }
        }));
        
        // Reload verification data to ensure consistency
        await loadVerificationData();
      } else {
        const errorData = await response.json();
        console.error('Failed to save verification data for item:', itemId, errorData);
        alert('सत्यापन डाटा सेभ गर्न असफल!');
      }
    } catch (error) {
      console.error('Error saving verification data:', error);
      alert('सत्यापन डाटा सेभ गर्नेमा समस्या भयो!');
    }
  };

  // Load existing verification data
  const loadVerificationData = async () => {
    try {
      console.log('Loading verification data...');
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403-item-verification/`);
      if (response.ok) {
        const data = await response.json();
        console.log('Verification data count:', data.results?.length || 0);
        console.log('Raw verification data:', data);
        
        const verificationMap = {};
        
        if (data.results && Array.isArray(data.results)) {
          data.results.forEach(verification => {
            // Use the form403_item ID as the key
            verificationMap[verification.form403_item] = {
              status: verification.status,
              comment: verification.comment || '',
              location: verification.location || ''
            };
            console.log(`Verification data for item ${verification.form403_item}:`, verificationMap[verification.form403_item]);
          });
        }
        
        setVerificationData(verificationMap);
        console.log('Verification data loaded for items:', Object.keys(verificationMap));
        console.log('Final verification map:', verificationMap);
      } else {
        console.error('Failed to load verification data, response not ok');
        const errorData = await response.json();
        console.error('Error response:', errorData);
      }
    } catch (error) {
      console.error('Error loading verification data:', error);
    }
  };

  const handleVerificationUpdate = async (formId) => {
    try {
      setVerificationLoading(true);
      
      const table = document.querySelector('.dataUpdateContainer table tbody');
      if (!table) {
        throw new Error('Table not found');
      }
      
      const formIndex = verificationFormList.findIndex(f => f.id === formId);
      if (formIndex === -1) {
        throw new Error('Form not found');
      }
      
      const row = table.children[formIndex];
      if (!row) {
        throw new Error('Row not found');
      }
      
      const statusSelect = row.querySelector('select');
      const commentInput = row.querySelector('input[type="text"]:nth-of-type(1)');
      const locationInput = row.querySelector('input[type="text"]:nth-of-type(2)');
      
      const status = statusSelect ? statusSelect.value : 'pending';
      const comment = commentInput ? commentInput.value : '';
      const location = locationInput ? locationInput.value : '';
      
      const updatedData = {
        status: status,
        comment: comment,
        location: location
      };
      
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/${formId}/update-verification/`, {
        method: 'PATCH',
        body: JSON.stringify(updatedData),
      });
      
      if (response.ok) {
        alert('सत्यापन डाटा सफलतापूर्वक अपडेट गरियो!');
        fetchVerificationFormList(verificationCurrentPage);
      } else {
        throw new Error('Failed to update verification data');
      }
    } catch (error) {
      console.error('Error updating verification data:', error);
      alert('सत्यापन डाटा अपडेट गर्न असफल!');
    } finally {
      setVerificationLoading(false);
    }
  };

  // Helper function to construct proper signature URL
  const constructSignatureUrl = (signaturePath) => {
    if (!signaturePath) return null;
    
    console.log('Constructing URL for signature path:', signaturePath);
    
    // If it's already a full URL, return as is
    if (signaturePath.startsWith('http://') || signaturePath.startsWith('https://')) {
      console.log('Full URL detected, returning as is:', signaturePath);
      return signaturePath;
    }
    
    // If it starts with a slash, it's a relative path, prepend API_BASE_URL
    if (signaturePath.startsWith('/')) {
      const fullUrl = `${API_BASE_URL}${signaturePath}`;
      console.log('Relative path with slash, constructed URL:', fullUrl);
      return fullUrl;
    }
    
    // If it doesn't start with slash, it might be a relative path, prepend API_BASE_URL with slash
    const fullUrl = `${API_BASE_URL}/${signaturePath}`;
    console.log('Relative path without slash, constructed URL:', fullUrl);
    return fullUrl;
  };

  // Load form data
  const loadFormData = async (id) => {
    if (!id) return;
    
    setIsLoading(true);
    try {
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/${id}/`);
      if (response.ok) {
        const data = await response.json();
        
        console.log('Raw data from backend:', data);
        
        const mappedData = {
          officeName: data.office_name || data.officeName || 'मध्यपश्चिम विश्वविद्यालय',
          officeAddress: data.office_address || data.officeAddress || 'वीरेन्द्रनगर, सुर्खेत',
          officeCode: data.office_code || data.officeCode || '',
          formNumber: data.form_number || data.formNumber || '',
          admissionDate: data.admission_date || data.admissionDate || '',
          admissionReportNumber: data.admission_report_number || data.admissionReportNumber || '',
          reportNumber: data.report_number || data.reportNumber || '',
          personName: data.person_name || data.personName || '',
          entityName: data.entity_name || data.entityName || '',
          address: data.address || '',
          phoneNumber: data.phone_number || data.phoneNumber || '',
          registrationNumber: data.registration_number || data.registrationNumber || '',
          panNumber: data.pan_number || data.panNumber || '',
          totalAmount: data.total_amount || data.totalAmount || '',
          vatAmount: data.vat_amount || data.vatAmount || '',
          grandTotal: data.grand_total || data.grandTotal || '',
          fontwalName: data.fontwal_name || data.fontwalName || '',
          fontwalDesignation: data.fontwal_designation || data.fontwalDesignation || '',
          fontwalDate: data.fontwal_date || data.fontwalDate || '',
          branchHeadName: data.branch_head_name || data.branchHeadName || '',
          branchHeadDesignation: data.branch_head_designation || data.branchHeadDesignation || '',
          branchHeadDate: data.branch_head_date || data.branchHeadDate || '',
          officeHeadName: data.office_head_name || data.officeHeadName || '',
          officeHeadDesignation: data.office_head_designation || data.officeHeadDesignation || '',
          officeHeadDate: data.office_head_date || data.officeHeadDate || '',
          firmName: data.firm_name || data.firmName || '',
          firmSignature: data.firm_signature || data.firmSignature || '',
          firmDate: data.firm_date || data.firmDate || '',
          items: data.items || []
        };
        
        console.log('Mapped form data:', mappedData);
        setFormData(mappedData);
        setFormId(id);
        localStorage.setItem('lastForm403Id', id);
        
        // Load saved signatures from model fields
        const savedSignatures = {};
        console.log('Raw signature data from backend:', {
          fontwal_signature: data.fontwal_signature,
          branch_head_signature: data.branch_head_signature,
          office_head_signature: data.office_head_signature
        });
        
        if (data.fontwal_signature) {
          const signatureUrl = constructSignatureUrl(data.fontwal_signature);
          savedSignatures.fontwalSignature = {
            preview: signatureUrl,
            file: null
          };
          console.log('Loading fontwal signature:', savedSignatures.fontwalSignature);
        }
        if (data.branch_head_signature) {
          const signatureUrl = constructSignatureUrl(data.branch_head_signature);
          savedSignatures.branchHeadSignature = {
            preview: signatureUrl,
            file: null
          };
          console.log('Loading branch head signature:', savedSignatures.branchHeadSignature);
        }
        if (data.office_head_signature) {
          const signatureUrl = constructSignatureUrl(data.office_head_signature);
          savedSignatures.officeHeadSignature = {
            preview: signatureUrl,
            file: null
          };
          console.log('Loading office head signature:', savedSignatures.officeHeadSignature);
        }
        
        // Only update signatures if we have saved ones
        if (Object.keys(savedSignatures).length > 0) {
          console.log('Setting signatures:', savedSignatures);
          setSignatures(prevSignatures => ({
            ...prevSignatures,
            ...savedSignatures
          }));
          
          // Don't automatically set visibility - let user click to show signatures
          // const newVisibility = {};
          // Object.keys(savedSignatures).forEach(key => {
          //   newVisibility[key] = true;
          // });
          
          // setSignatureVisibility(prev => ({
          //   ...prev,
          //   ...newVisibility
          // }));
        }
        
        // Always load items data when form is loaded, not just for updates
        if (data.items && data.items.length > 0) {
          const formattedItems = data.items.map((item, index) => ({
            id: `item-${index + 1}`,
            serialNumber: (index + 1).toString(),
            ...item
          }));
          setEmptyRows(formattedItems);
    } else {
          // If no items, reset to default empty rows
          setEmptyRows([
            { id: 'empty-1', serialNumber: '१', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' },
            { id: 'empty-2', serialNumber: '२', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' },
            { id: 'empty-3', serialNumber: '३', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' },
            { id: 'empty-4', serialNumber: '४', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' },
            { id: 'empty-5', serialNumber: '५', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' }
          ]);
        }
      }
    } catch (error) {
      console.error('Error loading form data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Submit function
  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    
    try {
      const submitData = new FormData();
      
      // Complete field mapping for all Form403 model fields
      const fieldMapping = {
        // Header Information
        officeName: 'office_name',
        officeAddress: 'office_address', 
        officeCode: 'office_code',
        
        // Form Information
        formNumber: 'form_number', 
        admissionDate: 'admission_date', 
        admissionReportNumber: 'admission_report_number',
        reportNumber: 'report_number',
        
        // Entity Information
        personName: 'person_name', 
        entityName: 'entity_name',
        address: 'address', 
        phoneNumber: 'phone_number', 
        registrationNumber: 'registration_number',
        panNumber: 'pan_number',
        
        // Financial Information
        totalAmount: 'total_amount', 
        vatAmount: 'vat_amount',
        grandTotal: 'grand_total',
        
        // Signature Information - Names
        fontwalName: 'fontwal_name', 
        fontwalDesignation: 'fontwal_designation', 
        fontwalDate: 'fontwal_date',
        branchHeadName: 'branch_head_name', 
        branchHeadDesignation: 'branch_head_designation', 
        branchHeadDate: 'branch_head_date',
        officeHeadName: 'office_head_name', 
        officeHeadDesignation: 'office_head_designation', 
        officeHeadDate: 'office_head_date',
        
        // Firm Information
        firmName: 'firm_name', 
        firmSignature: 'firm_signature',
        firmDate: 'firm_date'
      };
      
      // Add form fields to FormData
      console.log('Form data being processed:', formData);
      Object.keys(formData).forEach(key => {
        if (fieldMapping[key]) {
          const value = formData[key] || '';
          submitData.append(fieldMapping[key], value);
          console.log(`Adding field ${fieldMapping[key]}: ${value}`);
        } else {
          console.log(`Skipping field ${key} - not in mapping`);
        }
      });
      
      // Process items data - convert to proper format for backend
      const validItems = emptyRows.filter(row => row.itemName && row.itemName.trim() !== '');
      const processedItems = validItems.map(row => ({
        serial_number: row.serialNumber,
        purchase_order_number: row.purchaseOrderNumber || '',
        classification_code: row.classificationCode || '',
        ledger_page_number: row.ledgerPageNumber || '',
        item_name: row.itemName || '',
        specification: row.specification || '',
        item_identification_number: row.itemIdentificationNumber || '',
        model_number: row.modelNumber || '',
        unit: row.unit || '',
        quantity: row.quantity || '',
        rate: row.rate || '',
        total_excluding_vat: row.totalExcludingVAT || '',
        vat: row.vat || '',
        total_item_value: row.totalItemValue || '',
        other_expenses: row.otherExpenses || '',
        total_with_other_expenses: row.totalWithOtherExpenses || '',
        remarks: row.remarks || ''
      }));
      
      console.log('Processed items:', processedItems);
      submitData.append('items', JSON.stringify(processedItems));
      
      // Add signature files
      if (signatures.fontwalSignature?.file) {
        submitData.append('fontwal_signature', signatures.fontwalSignature.file);
      }
      if (signatures.branchHeadSignature?.file) {
        submitData.append('branch_head_signature', signatures.branchHeadSignature.file);
      }
      if (signatures.officeHeadSignature?.file) {
        submitData.append('office_head_signature', signatures.officeHeadSignature.file);
      }
      
      // Determine if this is an update or create operation
      const isUpdateMode = selectedFormForUpdate && formId;
      const url = isUpdateMode ? `${API_BASE_URL}/api/form403/${formId}/` : `${API_BASE_URL}/api/form403/`;
      const method = isUpdateMode ? 'PUT' : 'POST';
      
      console.log('=== SUBMIT DEBUG INFO ===');
      console.log('Update mode:', isUpdateMode);
      console.log('Selected form for update:', selectedFormForUpdate);
      console.log('Form ID:', formId);
      console.log('URL:', url);
      console.log('Method:', method);
      console.log('Active tab:', activeTab);
      console.log('Show update form:', showUpdateForm);
      console.log('========================');
      
      console.log('Submitting to:', url);
      console.log('Method:', method);
      console.log('FormData entries:');
      for (let [key, value] of submitData.entries()) {
        console.log(`${key}: ${typeof value === 'object' ? 'File' : value}`);
      }
      
      const response = await makeAuthenticatedRequest(url, {
        method: method,
        body: submitData,
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Success response:', result);
        
        if (selectedFormForUpdate) {
          // Show success popup for update
          showSuccessPopup('फारम सफलतापूर्वक अपडेट गरियो!');
          setSelectedFormForUpdate(null);
          setShowUpdateForm(false);
          setActiveTab('dataUpdate');
          fetchFormList(updateFormCurrentPage);
        } else {
          // Show success popup for new form
          showSuccessPopup('फारम सफलतापूर्वक सेभ गरियो!');
          
          // Clear form data for new entry
          clearFormData();
        }
      } else {
        const errorData = await response.json();
        console.error('Error response:', errorData);
        showErrorPopup(`फारम सेभ गर्नेमा समस्या भयो: ${errorData.message || errorData.error || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      showErrorPopup('फारम सेभ गर्नेमा समस्या भयो!');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to clear form data
  const clearFormData = () => {
    console.log('clearFormData called - resetting form state');
    setFormData({
      officeName: 'मध्यपश्चिम विश्वविद्यालय',
      officeAddress: 'वीरेन्द्रनगर, सुर्खेत',
      officeCode: '',
      formNumber: '',
      admissionDate: '',
      admissionReportNumber: '',
      reportNumber: '',
      personName: '',
      entityName: '',
      address: '',
      phoneNumber: '',
      registrationNumber: '',
      panNumber: '',
      totalAmount: '',
      vatAmount: '',
      grandTotal: '',
      fontwalName: '',
      fontwalDesignation: '',
      fontwalDate: '',
      branchHeadName: '',
      branchHeadDesignation: '',
      branchHeadDate: '',
      officeHeadName: '',
      officeHeadDesignation: '',
      officeHeadDate: '',
      firmName: '',
      firmSignature: '',
      firmDate: '',
      items: []
    });
    
    setEmptyRows([
      { id: 'empty-1', serialNumber: '१', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' },
      { id: 'empty-2', serialNumber: '२', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' },
      { id: 'empty-3', serialNumber: '३', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' },
      { id: 'empty-4', serialNumber: '४', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' },
      { id: 'empty-5', serialNumber: '५', purchaseOrderNumber: '', classificationCode: '', ledgerPageNumber: '', itemName: '', specification: '', itemIdentificationNumber: '', modelNumber: '', unit: '', quantity: '', rate: '', totalExcludingVAT: '', vat: '', totalItemValue: '', otherExpenses: '', totalWithOtherExpenses: '', remarks: '' }
    ]);
    
    // Clear signatures completely
    setSignatures({
      fontwalSignature: null,
      branchHeadSignature: null,
      officeHeadSignature: null
    });
    
    setSignatureVisibility({
      fontwalSignature: false,
      branchHeadSignature: false,
      officeHeadSignature: false
    });
    
    setFormId(null);
    localStorage.removeItem('lastForm403Id');
  };

  // Function to populate form data for update
  const populateFormForUpdate = (formData) => {
    console.log('Populating form for update:', formData);
    
    // Populate main form fields
    setFormData({
      officeName: formData.office_name || 'मध्यपश्चिम विश्वविद्यालय',
      officeAddress: formData.office_address || 'वीरेन्द्रनगर, सुर्खेत',
      officeCode: formData.office_code || '',
      formNumber: formData.form_number || '',
      admissionDate: formData.admission_date || '',
      admissionReportNumber: formData.admission_report_number || '',
      reportNumber: formData.report_number || '',
      personName: formData.person_name || '',
      entityName: formData.entity_name || '',
      address: formData.address || '',
      phoneNumber: formData.phone_number || '',
      registrationNumber: formData.registration_number || '',
      panNumber: formData.pan_number || '',
      totalAmount: formData.total_amount || '',
      vatAmount: formData.vat_amount || '',
      grandTotal: formData.grand_total || '',
      fontwalName: formData.fontwal_name || '',
      fontwalDesignation: formData.fontwal_designation || '',
      fontwalDate: formData.fontwal_date || '',
      branchHeadName: formData.branch_head_name || '',
      branchHeadDesignation: formData.branch_head_designation || '',
      branchHeadDate: formData.branch_head_date || '',
      officeHeadName: formData.office_head_name || '',
      officeHeadDesignation: formData.office_head_designation || '',
      officeHeadDate: formData.office_head_date || '',
      firmName: formData.firm_name || '',
      firmSignature: formData.firm_signature || '',
      firmDate: formData.firm_date || '',
      items: formData.items || []
    });

    // Populate items table
    if (formData.items && formData.items.length > 0) {
      const populatedRows = formData.items.map((item, index) => ({
        id: `item-${item.id || index + 1}`,
        serialNumber: (index + 1).toString(),
        purchaseOrderNumber: item.purchase_order_number || '',
        classificationCode: item.classification_code || '',
        ledgerPageNumber: item.ledger_page_number || '',
        itemName: item.item_name || '',
        specification: item.specification || '',
        itemIdentificationNumber: item.item_identification_number || '',
        modelNumber: item.model_number || '',
        unit: item.unit || '',
        quantity: item.quantity || '',
        rate: item.rate || '',
        totalExcludingVAT: item.total_excluding_vat || '',
        vat: item.vat || '',
        totalItemValue: item.total_item_value || '',
        otherExpenses: item.other_expenses || '',
        totalWithOtherExpenses: item.total_with_other_expenses || '',
        remarks: item.remarks || ''
      }));
      
      // Add empty rows if needed
      while (populatedRows.length < 5) {
        const newIndex = populatedRows.length + 1;
        populatedRows.push({
          id: `empty-${newIndex}`,
          serialNumber: newIndex.toString(),
          purchaseOrderNumber: '',
          classificationCode: '',
          ledgerPageNumber: '',
          itemName: '',
          specification: '',
          itemIdentificationNumber: '',
          modelNumber: '',
          unit: '',
          quantity: '',
          rate: '',
          totalExcludingVAT: '',
          vat: '',
          totalItemValue: '',
          otherExpenses: '',
          totalWithOtherExpenses: '',
          remarks: ''
        });
      }
      
      setEmptyRows(populatedRows);
    }

    // Set form ID for update
    console.log('Setting formId to:', formData.id);
    setFormId(formData.id);
  };

  // useEffect to populate form when selectedFormForUpdate changes
  useEffect(() => {
    console.log('useEffect triggered - selectedFormForUpdate:', selectedFormForUpdate);
    if (selectedFormForUpdate) {
      populateFormForUpdate(selectedFormForUpdate);
    }
  }, [selectedFormForUpdate]);

  // Function to handle cancel update
  const handleCancelUpdate = () => {
    console.log('handleCancelUpdate called - clearing update state');
    setSelectedFormForUpdate(null);
    setShowUpdateForm(false);
    setActiveTab('dataUpdate');
    clearFormData();
    showSuccessPopup('फारम सम्पादन रद्द गरियो!');
  };

  // Function to show success popup
  const showSuccessPopup = (message) => {
    // Create a custom popup
    const popup = document.createElement('div');
    popup.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #4CAF50;
      color: white;
      padding: 20px 30px;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      z-index: 10000;
      font-family: 'Noto Sans Devanagari', Arial, sans-serif;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      min-width: 300px;
    `;
    popup.textContent = message;
    
    // Add to body
    document.body.appendChild(popup);
    
    // Remove after 3 seconds
    setTimeout(() => {
      if (document.body.contains(popup)) {
        document.body.removeChild(popup);
      }
    }, 3000);
  };

  // Function to show error popup
  const showErrorPopup = (message) => {
    // Create a custom popup
    const popup = document.createElement('div');
    popup.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #f44336;
      color: white;
      padding: 20px 30px;
      border-radius: 8px;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      z-index: 10000;
      font-family: 'Noto Sans Devanagari', Arial, sans-serif;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      min-width: 300px;
    `;
    popup.textContent = message;
    
    // Add to body
    document.body.appendChild(popup);
    
    // Remove after 5 seconds
    setTimeout(() => {
      if (document.body.contains(popup)) {
        document.body.removeChild(popup);
      }
    }, 5000);
  };

  // Function to save signatures
  const handleSaveSignatures = async () => {
    if (isSavingSignatures) return;
    setIsSavingSignatures(true);
    
    try {
      const submitData = new FormData();
      
      // Add signature files
      if (signatures.fontwalSignature?.file) {
        submitData.append('fontwal_signature', signatures.fontwalSignature.file);
      }
      if (signatures.branchHeadSignature?.file) {
        submitData.append('branch_head_signature', signatures.branchHeadSignature.file);
      }
      if (signatures.officeHeadSignature?.file) {
        submitData.append('office_head_signature', signatures.officeHeadSignature.file);
      }
      
      // Add signature text data
      submitData.append('fontwal_name', formData.fontwalName || '');
      submitData.append('fontwal_designation', formData.fontwalDesignation || '');
      submitData.append('fontwal_date', formData.fontwalDate || '');
      submitData.append('branch_head_name', formData.branchHeadName || '');
      submitData.append('branch_head_designation', formData.branchHeadDesignation || '');
      submitData.append('branch_head_date', formData.branchHeadDate || '');
      submitData.append('office_head_name', formData.officeHeadName || '');
      submitData.append('office_head_designation', formData.officeHeadDesignation || '');
      submitData.append('office_head_date', formData.officeHeadDate || '');
      
      // If we have a form ID, update existing form
      if (formId) {
        const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/${formId}/`, {
          method: 'PUT',
          body: submitData,
        });

        if (response.ok) {
          showSuccessPopup('दस्तखतहरू सफलतापूर्वक सेभ गरियो!');
          
          // Reload form data to get updated signature URLs
          await loadFormData(formId);
        } else {
          const errorData = await response.json();
          showErrorPopup(`दस्तखतहरू सेभ गर्नेमा समस्या भयो: ${errorData.message || 'Unknown error'}`);
        }
      } else {
        // Create a new form with just signatures
        // Add default form values to make it valid
        submitData.append('office_name', formData.officeName || 'मध्यपश्चिम विश्वविद्यालय');
        submitData.append('office_address', formData.officeAddress || 'वीरेन्द्रनगर, सुर्खेत');
        submitData.append('form_number', 'SIGNATURE_ONLY');
        submitData.append('entity_name', 'Signature Template');
        
        const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/form403/`, {
          method: 'POST',
          body: submitData,
        });

        if (response.ok) {
          const result = await response.json();
          setFormId(result.id);
          localStorage.setItem('lastForm403Id', result.id);
          
          showSuccessPopup('दस्तखतहरू सफलतापूर्वक सेभ गरियो! अब मुख्य फाराममा जानुहोस्');
          
          // Reload form data to get updated signature URLs
          await loadFormData(result.id);
        } else {
          const errorData = await response.json();
          showErrorPopup(`दस्तखतहरू सेभ गर्नेमा समस्या भयो: ${errorData.message || 'Unknown error'}`);
        }
      }
    } catch (error) {
      console.error('Error saving signatures:', error);
      showErrorPopup('दस्तखतहरू सेभ गर्नेमा समस्या भयो!');
    } finally {
      setIsSavingSignatures(false);
    }
  };

  // Effects
  useEffect(() => {
    console.log('Active tab changed to:', activeTab);
    console.log('User authenticated:', isAuthenticated);
    console.log('User:', user);
    
    if (activeTab === 'dataUpdate') {
      console.log('Fetching form list for data update tab');
      fetchFormList();
    }
  }, [activeTab, updateFormSearchTerm, updateFormItemsPerPage]);

  useEffect(() => {
    if (activeTab === 'viewData') {
      fetchViewData();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'dataVerification') {
      console.log('Data verification tab activated - fetching form list');
      fetchVerificationFormList();
    }
  }, [activeTab, verificationSearchTerm, verificationItemsPerPage]);

  // Load verification data after form list is loaded
  useEffect(() => {
    if (activeTab === 'dataVerification' && verificationFormList.length > 0) {
      console.log('Loading verification data after form list is loaded');
      loadVerificationData(); // Load existing verification data
    }
  }, [activeTab, verificationFormList]);

  // Load verification data on component mount (only if not in dataVerification tab)
  useEffect(() => {
    if (activeTab !== 'dataVerification') {
      console.log('Loading verification data on component mount');
      loadVerificationData();
    }
  }, []);

  // Update pagination when filters change
  useEffect(() => {
    if (activeTab === 'dataVerification') {
      const filteredData = getFilteredVerificationRows();
      setVerificationTotalPages(Math.ceil(filteredData.length / verificationItemsPerPage));
      setVerificationCurrentPage(1); // Reset to first page when filters change
    }
  }, [verificationFilters, verificationItemsPerPage, activeTab]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    
    // Only load form data if there's a specific ID in URL (for direct links)
    // Don't auto-load from localStorage for fresh form creation
    if (id) {
      loadFormData(id);
    } else {
      // Clear any existing form ID from localStorage to ensure fresh start
      localStorage.removeItem('lastForm403Id');
      setFormId(null);
    }
  }, []);

  if (isLoading) {
    return (
      <div className={styles.form403Container}>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <p>फारम लोड गर्दै...</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.form403Container}>
      {/* Tab Navigation */}
      <div className={styles.tabNavigation}>
        <button
          className={`${styles.tabButton} ${activeTab === 'main' ? styles.active : ''}`}
          onClick={() => {
            // If we're in update mode and switching to main form, ask for confirmation
            if (selectedFormForUpdate && activeTab !== 'main') {
              const confirmed = window.confirm('तपाईं फारम सम्पादन मोडबाट बाहिर जान चाहनुहुन्छ? यसले सबै परिवर्तनहरू रद्द गर्नेछ।');
              if (confirmed) {
                console.log('Switching to main form from update mode - clearing update state');
                setSelectedFormForUpdate(null);
                setShowUpdateForm(false);
                clearFormData();
                setActiveTab('main');
                showSuccessPopup('फारम सम्पादन रद्द गरियो!');
              }
            } else {
              setActiveTab('main');
            }
          }}
        >
          मुख्य फाराम
        </button>
                 <button
           className={`${styles.tabButton} ${activeTab === 'signatures' ? styles.active : ''}`}
           onClick={() => setActiveTab('signatures')}
         >
           दस्तखत अपलोड
         </button>
        <button
          className={`${styles.tabButton} ${activeTab === 'viewData' ? styles.active : ''}`}
          onClick={() => setActiveTab('viewData')}
        >
          डाटा हेर्नुहोस्
        </button>
                           <button
          className={`${styles.tabButton} ${activeTab === 'dataUpdate' ? styles.active : ''}`}
          onClick={() => setActiveTab('dataUpdate')}
        >
          डाटा अपडेट
                           </button>
        <button
          className={`${styles.tabButton} ${activeTab === 'dataVerification' ? styles.active : ''}`}
          onClick={() => setActiveTab('dataVerification')}
        >
          डाटा सत्यापन
            </button>
          </div>

      {/* Main Form Tab */}
      {activeTab === 'main' && (
        <MainForm
          formData={formData}
          emptyRows={emptyRows}
          handleInputChange={handleInputChange}
          handleDateInput={handleDateInput}
          handleReportNumberInput={handleReportNumberInput}
          handleRowChange={handleRowChange}
          addNewRow={addNewRow}
          removeRow={removeRow}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          selectedFormForUpdate={selectedFormForUpdate}
          signatures={signatures}
          signatureVisibility={signatureVisibility}
          handleSignatureVisibility={handleSignatureVisibility}
          setSelectedFormForUpdate={setSelectedFormForUpdate}
          setShowUpdateForm={setShowUpdateForm}
          setActiveTab={setActiveTab}
          clearFormData={clearFormData}
          handleCancelUpdate={handleCancelUpdate}
        />
      )}

             {/* Signatures Tab */}
       {activeTab === 'signatures' && (
        <Signature
          signatures={signatures}
          signatureVisibility={signatureVisibility}
          handleSignatureUpload={handleSignatureUpload}
          handleSignatureVisibility={handleSignatureVisibility}
          handleSignatureDelete={handleSignatureDelete}
          generateSignature={generateSignature}
          handleSaveSignatures={handleSaveSignatures}
          isSavingSignatures={isSavingSignatures}
          formData={formData}
          handleInputChange={handleInputChange}
        />
      )}

      {/* View Data Tab */}
      {activeTab === 'viewData' && (
        <ViewData
          viewDataItems={viewDataItems}
          viewDataLoading={viewDataLoading}
          viewDataForms={viewDataForms}
          selectedFormForView={selectedFormForView}
          filters={filters}
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          showFilters={showFilters}
          handleFilterChange={handleFilterChange}
          clearAllFilters={clearAllFilters}
          getFilteredRows={getFilteredRows}
          getPaginatedRows={getPaginatedRows}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          handleItemsPerPageChange={handleItemsPerPageChange}
          toggleFilters={toggleFilters}
          setSelectedFormForView={setSelectedFormForView}
          setActiveTab={setActiveTab}
        />
      )}

      {/* Data Update Tab */}
      {activeTab === 'dataUpdate' && (
        <UpdateData
          formList={formList}
          updateFormLoading={updateFormLoading}
          updateFormSearchTerm={updateFormSearchTerm}
          updateFormCurrentPage={updateFormCurrentPage}
          updateFormTotalPages={updateFormTotalPages}
          updateFormItemsPerPage={updateFormItemsPerPage}
          handleUpdateFormSearch={handleUpdateFormSearch}
          handleUpdateFormPageChange={handleUpdateFormPageChange}
          handleUpdateFormItemsPerPageChange={handleUpdateFormItemsPerPageChange}
          handleFormSelectForUpdate={handleFormSelectForUpdate}
          handleBulkDelete={handleBulkDelete}
          handleBulkExport={handleBulkExport}
          handleDuplicateForm={handleDuplicateForm}
        />
      )}

      {/* Data Verification Tab */}
      {activeTab === 'dataVerification' && (
        <VerifyData
          verificationFormList={verificationFormList}
          verificationLoading={verificationLoading}
          verificationSearchTerm={verificationSearchTerm}
          verificationCurrentPage={verificationCurrentPage}
          verificationTotalPages={verificationTotalPages}
          verificationItemsPerPage={verificationItemsPerPage}
          handleVerificationSearch={handleVerificationSearch}
          handleVerificationPageChange={handleVerificationPageChange}
          handleVerificationItemsPerPageChange={handleVerificationItemsPerPageChange}
          handleVerificationUpdate={handleVerificationUpdate}
          verificationData={verificationData}
          handleVerificationStatusChange={handleVerificationStatusChange}
          handleVerificationCommentChange={handleVerificationCommentChange}
          handleVerificationLocationChange={handleVerificationLocationChange}
          saveVerificationData={saveVerificationData}
          verificationFilters={verificationFilters}
          showVerificationFilters={showVerificationFilters}
          handleVerificationFilterChange={handleVerificationFilterChange}
          getFilteredVerificationRows={getFilteredVerificationRows}
          toggleVerificationFilters={toggleVerificationFilters}
        />
      )}
    </div>
  );
};

export default Form403;
